import { t } from "@web-monorepo/i18n/macro";
import { getImageSrc } from "@web-monorepo/static-assets";

export type BedtimeStoryEpisode = {
  title: string;
  seriesTitle: string;
  releaseDate?: Date;
  imgSrc: string;
  fullscreenImgSrc: string;
  audioSrc: string;
  audioDuration: string;
  loggingId: string;
};

export const episodes = () => [
  //Optimism Series:
  {
    title: t`Optimism Part ${{ part: 1 }}`,
    seriesTitle: t`Optimism`,
    releaseDate: new Date("2099-04-30"),
    imgSrc: "https://static.classdojo.com/img/ideas_platform/activities/positive-thinking/ep1/Mojo_EpCovers_10.jpg",
    fullscreenImgSrc:
      "https://static.classdojo.com/img/ideas_platform/activities/positive-thinking/ep1/Mojo_EpCovers_10.jpg",
    audioSrc: "https://static.classdojo.com/toolkit-static/bedtime/optimism_1.mp3",
    audioDuration: "3",
    loggingId: "optimism_1",
  },
  {
    title: t`Optimism Part ${{ part: 2 }}`,
    seriesTitle: t`Optimism`,
    releaseDate: new Date("2099-04-30"),
    imgSrc: "https://static.classdojo.com/img/ideas_platform/activities/positive-thinking/ep2/Mojo_EpCovers_11.jpg",
    fullscreenImgSrc:
      "https://static.classdojo.com/img/ideas_platform/activities/positive-thinking/ep2/Mojo_EpCovers_11.jpg",
    audioSrc: "https://static.classdojo.com/toolkit-static/bedtime/optimism_2.mp3",
    audioDuration: "3",
    loggingId: "optimism_2",
  },
  {
    title: t`Optimism Part ${{ part: 3 }}`,
    seriesTitle: t`Optimism`,
    releaseDate: new Date("2099-04-30"),
    imgSrc: "https://static.classdojo.com/img/ideas_platform/activities/positive-thinking/ep3/Mojo_EpCovers_12.jpg",
    fullscreenImgSrc:
      "https://static.classdojo.com/img/ideas_platform/activities/positive-thinking/ep3/Mojo_EpCovers_12.jpg",
    audioSrc: "https://static.classdojo.com/toolkit-static/bedtime/optimism_3.mp3",
    audioDuration: "3",
    loggingId: "optimism_3",
  },

  //Respect Series:
  {
    title: t`Respect Part ${{ part: 1 }}`,
    seriesTitle: t`Respect`,
    releaseDate: new Date("2099-04-30"),
    imgSrc: "https://static.classdojo.com/img/ideas_platform/activities/respect/ep1/Mojo_EpCovers_07.jpg",
    fullscreenImgSrc: "https://static.classdojo.com/img/ideas_platform/activities/respect/ep1/Mojo_EpCovers_07.jpg",
    audioSrc: "https://static.classdojo.com/toolkit-static/bedtime/respect_1.mp3",
    audioDuration: "3",
    loggingId: "respect_1",
  },
  {
    title: t`Respect Part ${{ part: 2 }}`,
    seriesTitle: t`Respect`,
    releaseDate: new Date("2099-04-30"),
    imgSrc: "https://static.classdojo.com/img/ideas_platform/activities/respect/ep2/Mojo_EpCovers_08.jpg",
    fullscreenImgSrc: "https://static.classdojo.com/img/ideas_platform/activities/respect/ep2/Mojo_EpCovers_08.jpg",
    audioSrc: "https://static.classdojo.com/toolkit-static/bedtime/respect_2.mp3",
    audioDuration: "3",
    loggingId: "respect_2",
  },
  {
    title: t`Respect Part ${{ part: 3 }}`,
    seriesTitle: t`Respect`,
    releaseDate: new Date("2099-04-30"),
    imgSrc: "https://static.classdojo.com/img/ideas_platform/activities/respect/ep3/Mojo_EpCovers_09.jpg",
    fullscreenImgSrc: "https://static.classdojo.com/img/ideas_platform/activities/respect/ep3/Mojo_EpCovers_09.jpg",
    audioSrc: "https://static.classdojo.com/toolkit-static/bedtime/respect_3.mp3",
    audioDuration: "3",
    loggingId: "respect_3",
  },

  //Big Challenges Series:
  {
    title: t`Big Challenges Part ${{ part: 1 }}`,
    seriesTitle: t`Big Challenges`,
    releaseDate: new Date("2099-04-30"),
    imgSrc: "https://static.classdojo.com/img/ideas_platform/activities/big-challenges/ep1/Mojo_EpCovers_04.jpg",
    fullscreenImgSrc:
      "https://static.classdojo.com/img/ideas_platform/activities/big-challenges/ep1/Mojo_EpCovers_04.jpg",
    audioSrc: "https://static.classdojo.com/toolkit-static/bedtime/big_challenges_1.mp3",
    audioDuration: "3",
    loggingId: "big_challenges_1",
  },
  {
    title: t`Big Challenges Part ${{ part: 2 }}`,
    seriesTitle: t`Big Challenges`,
    releaseDate: new Date("2099-04-30"),
    imgSrc: "https://static.classdojo.com/img/ideas_platform/activities/big-challenges/ep2/Mojo_EpCovers_05.jpg",
    fullscreenImgSrc:
      "https://static.classdojo.com/img/ideas_platform/activities/big-challenges/ep2/Mojo_EpCovers_05.jpg",
    audioSrc: "https://static.classdojo.com/toolkit-static/bedtime/big_challenges_2.mp3",
    audioDuration: "3",
    loggingId: "big_challenges_2",
  },
  {
    title: t`Big Challenges Part ${{ part: 3 }}`,
    seriesTitle: t`Big Challenges`,
    releaseDate: new Date("2099-04-30"),
    imgSrc: "https://static.classdojo.com/img/ideas_platform/activities/big-challenges/ep3/Mojo_EpCovers_06.jpg",
    fullscreenImgSrc:
      "https://static.classdojo.com/img/ideas_platform/activities/big-challenges/ep3/Mojo_EpCovers_06.jpg",
    audioSrc: "https://static.classdojo.com/toolkit-static/bedtime/big_challenges_3.mp3",
    audioDuration: "3",
    loggingId: "big_challenges_3",
  },

  //Moods and Attitudes Series:
  {
    title: t`Moods and Attitudes Part ${{ part: 1 }}`,
    seriesTitle: t`Moods and Attitudes`,
    releaseDate: new Date("2099-04-30"),
    imgSrc: "https://static.classdojo.com/img/ideas_platform/activities/moods-and-attitudes/ep1/Mojo_EpCovers_01.jpg",
    fullscreenImgSrc:
      "https://static.classdojo.com/img/ideas_platform/activities/moods-and-attitudes/ep1/Mojo_EpCovers_01.jpg",
    audioSrc: "https://static.classdojo.com/toolkit-static/bedtime/moods_and_attitudes_1.mp3",
    audioDuration: "3",
    loggingId: "moods_and_attitudes_1",
  },
  {
    title: t`Moods and Attitudes Part ${{ part: 2 }}`,
    seriesTitle: t`Moods and Attitudes`,
    releaseDate: new Date("2099-04-30"),
    imgSrc: "https://static.classdojo.com/img/ideas_platform/activities/moods-and-attitudes/ep2/Mojo_EpCovers_02.jpg",
    fullscreenImgSrc:
      "https://static.classdojo.com/img/ideas_platform/activities/moods-and-attitudes/ep2/Mojo_EpCovers_02.jpg",
    audioSrc: "https://static.classdojo.com/toolkit-static/bedtime/moods_and_attitudes_2.mp3",
    audioDuration: "3",
    loggingId: "moods_and_attitudes_2",
  },
  {
    title: t`Moods and Attitudes Part ${{ part: 3 }}`,
    seriesTitle: t`Moods and Attitudes`,
    releaseDate: new Date("2099-04-30"),
    imgSrc: "https://static.classdojo.com/img/ideas_platform/activities/moods-and-attitudes/ep3/Mojo_EpCovers_03.jpg",
    fullscreenImgSrc:
      "https://static.classdojo.com/img/ideas_platform/activities/moods-and-attitudes/ep3/Mojo_EpCovers_03.jpg",
    audioSrc: "https://static.classdojo.com/toolkit-static/bedtime/moods_and_attitudes_3.mp3",
    audioDuration: "4",
    loggingId: "moods_and_attitudes_3",
  },

  //Mindfulness Series:
  {
    title: t`Mindfulness`,
    seriesTitle: t`Mindfulness`,
    releaseDate: new Date("2020-07-08"),
    imgSrc: "https://static.classdojo.com/img/ideas_platform/ideas/the_mojo_show/s04e01/cover.jpg",
    fullscreenImgSrc: "https://static.classdojo.com/img/ideas_platform/ideas/the_mojo_show/s04e01/cover.jpg",
    audioSrc: "https://static.classdojo.com/toolkit-static/bedtime/mindfulness_1.mp3",
    audioDuration: "3",
    loggingId: "mindfulness_1",
  },

  //Empathy Series:
  {
    title: t`Empathy Part ${{ part: 1 }}`,
    seriesTitle: t`Empathy`,
    releaseDate: new Date("2020-06-23"),
    imgSrc: "https://static.classdojo.com/img/ideas_platform/ideas/the_mojo_show/s03e01/cover.jpg",
    fullscreenImgSrc: "https://static.classdojo.com/img/ideas_platform/ideas/the_mojo_show/s03e01/cover.jpg",
    audioSrc: "https://static.classdojo.com/toolkit-static/bedtime/empathy_1.mp3",
    audioDuration: "5",
    loggingId: "empathy_1",
  },
  {
    title: t`Empathy Part ${{ part: 2 }}`,
    seriesTitle: t`Empathy`,
    releaseDate: new Date("2020-06-23"),
    imgSrc: "https://static.classdojo.com/img/ideas_platform/ideas/the_mojo_show/s03e02/cover.jpg",
    fullscreenImgSrc: "https://static.classdojo.com/img/ideas_platform/ideas/the_mojo_show/s03e02/cover.jpg",
    audioSrc: "https://static.classdojo.com/toolkit-static/bedtime/empathy_2.mp3",
    audioDuration: "4",
    loggingId: "empathy_2",
  },
  {
    title: t`Empathy Part ${{ part: 3 }}`,
    seriesTitle: t`Empathy`,
    releaseDate: new Date("2020-06-23"),
    imgSrc: "https://static.classdojo.com/img/ideas_platform/ideas/the_mojo_show/s03e03/cover.jpg",
    fullscreenImgSrc: "https://static.classdojo.com/img/ideas_platform/ideas/the_mojo_show/s03e03/cover.jpg",
    audioSrc: "https://static.classdojo.com/toolkit-static/bedtime/empathy_3.mp3",
    audioDuration: "5",
    loggingId: "empathy_3",
  },

  //Perseverance Series:
  {
    title: t`Perseverance Part ${{ part: 1 }}`,
    seriesTitle: t`Perseverance`,
    releaseDate: new Date("2020-06-07"),
    imgSrc: "https://static.classdojo.com/img/ideas_platform/ideas/the_mojo_show/s02e01/cover.jpg",
    fullscreenImgSrc: "https://static.classdojo.com/img/ideas_platform/ideas/the_mojo_show/s02e01/cover.jpg",
    audioSrc: "https://static.classdojo.com/toolkit-static/bedtime/perseverance_1.mp3",
    audioDuration: "4",
    loggingId: "perseverance_1",
  },
  {
    title: t`Perseverance Part ${{ part: 2 }}`,
    seriesTitle: t`Perseverance`,
    releaseDate: new Date("2020-06-07"),
    imgSrc: "https://static.classdojo.com/img/ideas_platform/ideas/the_mojo_show/s02e02/cover.jpg",
    fullscreenImgSrc: "https://static.classdojo.com/img/ideas_platform/ideas/the_mojo_show/s02e02/cover.jpg",
    audioSrc: "https://static.classdojo.com/toolkit-static/bedtime/perseverance_2.mp3",
    audioDuration: "4",
    loggingId: "perseverance_2",
  },
  {
    title: t`Perseverance Part ${{ part: 3 }}`,
    seriesTitle: t`Perseverance`,
    releaseDate: new Date("2020-06-07"),
    imgSrc: "https://static.classdojo.com/img/ideas_platform/ideas/the_mojo_show/s02e03/cover.jpg",
    fullscreenImgSrc: "https://static.classdojo.com/img/ideas_platform/ideas/the_mojo_show/s02e03/cover.jpg",
    audioSrc: "https://static.classdojo.com/toolkit-static/bedtime/perseverance_3.mp3",
    audioDuration: "4",
    loggingId: "perseverance_3",
  },

  //Growth Mindset Series:
  {
    title: t`Growth Mindset Part ${{ part: 1 }}`,
    seriesTitle: t`Growth Mindset`,
    releaseDate: new Date("2020-05-25"),
    imgSrc: "https://static.classdojo.com/img/ideas_platform/ideas/the_mojo_show/s01e01/cover.jpg",
    fullscreenImgSrc: "https://static.classdojo.com/img/ideas_platform/ideas/the_mojo_show/s01e01/cover.jpg",
    audioSrc: "https://static.classdojo.com/toolkit-static/bedtime/growth_mindset_1.mp3",
    audioDuration: "3",
    loggingId: "growth_mindset_1",
  },
  {
    title: t`Growth Mindset Part ${{ part: 2 }}`,
    seriesTitle: t`Growth Mindset`,
    releaseDate: new Date("2020-05-25"),
    imgSrc: "https://static.classdojo.com/img/ideas_platform/ideas/the_mojo_show/s01e02/cover.jpg",
    fullscreenImgSrc: "https://static.classdojo.com/img/ideas_platform/ideas/the_mojo_show/s01e02/cover.jpg",
    audioSrc: "https://static.classdojo.com/toolkit-static/bedtime/growth_mindset_2.mp3",
    audioDuration: "3",
    loggingId: "growth_mindset_2",
  },
  {
    title: t`Growth Mindset Part ${{ part: 3 }}`,
    seriesTitle: t`Growth Mindset`,
    releaseDate: new Date("2020-05-25"),
    imgSrc: "https://static.classdojo.com/img/ideas_platform/ideas/the_mojo_show/s01e03/cover.jpg",
    fullscreenImgSrc: "https://static.classdojo.com/img/ideas_platform/ideas/the_mojo_show/s01e03/cover.jpg",
    audioSrc: "https://static.classdojo.com/toolkit-static/bedtime/growth_mindset_3.mp3",
    audioDuration: "3",
    loggingId: "growth_mindset_3",
  },
  {
    title: t`Growth Mindset Part ${{ part: 4 }}`,
    seriesTitle: t`Growth Mindset`,
    releaseDate: new Date("2020-05-25"),
    imgSrc: "https://static.classdojo.com/img/ideas_platform/ideas/the_mojo_show/s01e04/cover.jpg",
    fullscreenImgSrc: "https://static.classdojo.com/img/ideas_platform/ideas/the_mojo_show/s01e04/cover.jpg",
    audioSrc: "https://static.classdojo.com/toolkit-static/bedtime/growth_mindset_4.mp3",
    audioDuration: "3",
    loggingId: "growth_mindset_4",
  },
  {
    title: t`Growth Mindset Part ${{ part: 5 }}`,
    seriesTitle: t`Growth Mindset`,
    releaseDate: new Date("2020-05-25"),
    imgSrc: "https://static.classdojo.com/img/ideas_platform/ideas/the_mojo_show/s01e05/cover.jpg",
    fullscreenImgSrc: "https://static.classdojo.com/img/ideas_platform/ideas/the_mojo_show/s01e05/cover.jpg",
    audioSrc: "https://static.classdojo.com/toolkit-static/bedtime/growth_mindset_5.mp3",
    audioDuration: "4",
    loggingId: "growth_mindset_5",
  },

  //Originally released stories (no release date = will be available to everyone anytime)
  {
    title: t`Mind Vacation`,
    seriesTitle: t`Meditation`,
    imgSrc: getImageSrc("toolkit/public/static/images/bedtime_wakeup.png"),
    fullscreenImgSrc: getImageSrc("toolkit/public/static/images/bedtime_wakeup.png"),
    audioSrc: "https://static.classdojo.com/toolkit-static/bedtime/mindvacation-2019.mp3",
    audioDuration: "4",
    loggingId: "mind_vacation",
  },
  {
    title: t`Bedtime Meditation`,
    seriesTitle: t`Meditation`,
    imgSrc: getImageSrc("toolkit/public/static/images/bedtime_sleep.png"),
    fullscreenImgSrc: getImageSrc("toolkit/public/static/images/bedtime_sleep.png"),
    audioSrc: "https://static.classdojo.com/toolkit-static/bedtime/bedtime-meditation-2019.mp3",
    audioDuration: "3",
    loggingId: "bedtime_meditation",
  },
  {
    title: t`Bruce Lee`,
    seriesTitle: t`History of Greatness`,
    imgSrc: getImageSrc("toolkit/public/static/images/history_bruce.png"),
    fullscreenImgSrc: getImageSrc("toolkit/public/static/images/history_bruce_portrait.png"),
    audioSrc: "https://static.classdojo.com/toolkit-static/history_of_greatness/bruce-lee.mp3",
    audioDuration: "10",
    loggingId: "bruce_lee",
  },
  {
    title: t`Frida Kahlo`,
    seriesTitle: t`History of Greatness`,
    imgSrc: getImageSrc("toolkit/public/static/images/history_frida.png"),
    fullscreenImgSrc: getImageSrc("toolkit/public/static/images/history_frida_portrait.png"),
    audioSrc: "https://static.classdojo.com/toolkit-static/history_of_greatness/frida-kahlo.mp3",
    audioDuration: "14",
    loggingId: "frida_kahlo",
  },
  {
    title: t`Harry Houdini`,
    seriesTitle: t`History of Greatness`,
    imgSrc: getImageSrc("toolkit/public/static/images/history_harry.png"),
    fullscreenImgSrc: getImageSrc("toolkit/public/static/images/history_harry_portrait.png"),
    audioSrc: "https://static.classdojo.com/toolkit-static/history_of_greatness/harry-houdini.mp3",
    audioDuration: "13",
    loggingId: "harry_houdini",
  },
  {
    title: t`Jane Goodall`,
    seriesTitle: t`History of Greatness`,
    imgSrc: getImageSrc("toolkit/public/static/images/history_jane.png"),
    fullscreenImgSrc: getImageSrc("toolkit/public/static/images/history_jane_portrait.png"),
    audioSrc: "https://static.classdojo.com/toolkit-static/history_of_greatness/jane-goodall.mp3",
    audioDuration: "13",
    loggingId: "jane_goodall",
  },
  {
    title: t`Mae Jemison`,
    seriesTitle: t`History of Greatness`,
    imgSrc: getImageSrc("toolkit/public/static/images/history_mae.png"),
    fullscreenImgSrc: getImageSrc("toolkit/public/static/images/history_mae_portrait.png"),
    audioSrc: "https://static.classdojo.com/toolkit-static/history_of_greatness/mae-jemison.mp3",
    audioDuration: "10",
    loggingId: "mae_jemison",
  },
];
